<div class="bg-white p-3 shadow-3 border-round-sm">
    <div class="rem-text-default flex align-items-center">
      <div class="rem-bg-light p-2 mr-2">
        <i class="pi pi-{{selectedAnalysisTypeIcon}} font-medium"></i>
      </div>
      <div class="text-lg">{{selectedAnalysisType}}</div>
    </div>


    <div class="mt-5">
      <div class="px-3 mb-5 flex align-items-center gap-3">
            <p-floatLabel>
              <p-multiSelect
                [style]="{width: '200px'}"
                id="creditorsPayments"
                [options]="creditors"
                [(ngModel)]="selectedCreditors"                
                optionLabel="label"
                filterBy="value,label">
                <ng-template let-creditor pTemplate="item">
                  <div class="flex align-items-center justify-content-between flex-1">
                    <div>{{ creditor.label }}</div>
                    <div class="ml-2">{{ creditor.value }}</div>
                  </div>
                </ng-template>
              </p-multiSelect>
            <label for="creditorsPayments">Select Clients</label>
            </p-floatLabel>
            
            <p-floatLabel>
              <p-calendar 
                    id="fromDatePayments"
                    [(ngModel)]="fromDate"
                    [readonlyInput]="true"      
                    [maxDate]="toDate"             
              >
              </p-calendar>
              <label for="fromDatePayments">From Date</label>
            </p-floatLabel>

            <p-floatLabel>
              <p-calendar 
                    id="toDatePayments"
                    [(ngModel)]="toDate"
                    [readonlyInput]="true"            
                    [minDate]="fromDate"
                    [maxDate]="todaysDate"
              >
              </p-calendar>
              <label for="toDatePayments">To Date</label>
            </p-floatLabel>

            <p-floatLabel *ngIf="selectedAnalysisType === 'Payments'">
              <p-multiSelect
                  [style]="{width: '200px'}"
                  id="transactionTypes"
                  [options]="transactionTypes"
                  [(ngModel)]="selectedTransactionTypes"                  
                  optionLabel="label"
                  optionValue="value"                   
                />                          
                <label for="transactionTypes">Transaction Type</label>
            </p-floatLabel>

            <p-floatLabel *ngIf="selectedAnalysisType === 'Payments'">
                 <p-dropdown 
                      [showClear]="true"
                      id="paymentStatuses" 
                      [options]="paymentStatuses"
                      [(ngModel)]="selectedPaymentStatus"
                      optionLabel="label" 
                      optionValue="value" 
                />   
                <label for="paymentStatuses">Payment Status</label>
            </p-floatLabel>

            <p-floatLabel *ngIf="selectedAnalysisType === 'Communications'">
              <p-multiSelect
                  [style]="{width: '200px'}"
                  id="channels"
                  [options]="channels"
                  [(ngModel)]="selectedChannels"                  
                  optionLabel="label"
                  optionValue="value"                   
                />                          
                <label for="channels">Channel</label>
            </p-floatLabel>

            <p-floatLabel *ngIf="selectedAnalysisType === 'Communications'">
              <p-multiSelect
                  [style]="{width: '200px'}"
                  id="statusNames"
                  [options]="statusNames"
                  [(ngModel)]="selectedStatusNames"                  
                  optionLabel="label"
                  optionValue="value"                   
                />                          
                <label for="statusNames">Status Names</label>
            </p-floatLabel>

            <p-floatLabel>
                <p-dropdown 
                      [showClear]="true"
                      id="timezonesPayments" 
                      [options]="timezones"
                      [(ngModel)]="selectedTimezone"
                      optionLabel="label" 
                      optionValue="value" 
                />
                <label for="timezonesPayments">Timezone</label>
            </p-floatLabel>
    
            <remitter-button
              label='Generate'
              icon='send'
              (click)="getGraph()"
            >     
            </remitter-button>
      </div>

      <p-tabView [(activeIndex)]="selectedGroupBy" (onChange)="onChangeSelectedGroupBy($event)">
        <p-tabPanel header="Daily"></p-tabPanel>
        <p-tabPanel header="Weekly"></p-tabPanel>
        <p-tabPanel header="Monthly"></p-tabPanel>    
        <p-tabPanel *ngIf="selectedAnalysisType === 'Communications'" header="Quarterly"></p-tabPanel>  
      </p-tabView>

    <div *ngIf="!chartOptions" class="flex align-items-center justify-content-center h-20rem">
        <div class="font-bold text-red-700">There is no data to display. Please adjust your filter.</div>
    </div>

     <div *ngIf="chartOptions">
      <div
        echarts
        [options]="chartOptions"
        class="chart">
      </div>
     </div>


    </div>

</div>